<template>
  <!--
    统一的开关控件，替代原来的“是/否”下拉框。
    后端返回的布尔值有时是数字 1/0、有时是字符串 "1"/"0"，
    这里做归一化：对外始终按数字 1/0 提交，避免 el-switch 严格比较时显示错误。
  -->
  <div class="setting-switch">
    <el-switch :value="on" :disabled="disabled" @change="onChange"></el-switch>
    <span class="setting-switch__state" :class="{ 'is-on': on }">
      {{ on ? $t("common.on") : $t("common.off") }}
    </span>
  </div>
</template>

<script>
  export default {
    name: "SettingSwitch",
    // 直接用 value/input 以支持 v-model
    props: {
      value: { type: [Number, String, Boolean], default: 0 },
      disabled: { type: Boolean, default: false }
    },
    computed: {
      on() {
        // 同时兼容 1 / "1" / true
        return this.value === 1 || this.value === "1" || this.value === true;
      }
    },
    methods: {
      onChange(checked) {
        this.$emit("input", checked ? 1 : 0);
        this.$emit("change", checked ? 1 : 0);
      }
    }
  };
</script>

<style scoped lang="scss">
  .setting-switch {
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .setting-switch__state {
    font-size: 12.5px;
    color: var(--vtm-ink-3);

    &.is-on {
      color: var(--vtm-mint-ink);
      font-weight: 500;
    }
  }
</style>
